export const SET_FETCHING = 'apartments/SET_FETCHING';
export const SET_APARTMENTS = 'apartments/SET_APARTMENTS';
export const SET_FEATURED_IDS = 'apartments/SET_FEATURED_IDS';
export const SET_SEARCHED_IDS = 'apartments/SET_SEARCHED_IDS';
